import styles from "./CategoryItemList.module.scss";

const marginLeft = 40;
const headerOffset = 150;

export const handleCartAnimation = () => {
  const parent = document.querySelector("#cartIconCircle");
  const span = document.createElement("span");
  const cartIcon = document.querySelector("#cartIconCircle");
  span.innerText = "+1";
  span.classList.add(styles.send_to_cart);
  parent?.insertBefore(span, parent.lastChild);

  if (cartIcon) {
    setTimeout(function () {
      span.remove();
      cartIcon.classList.add(styles.shake);
      setTimeout(function () {
        cartIcon.classList.remove(styles.shake);
      }, 500);
    }, 500);
  }
};

const updateCategoryTab = (
  section: any,
  navElm: any,
  offset: any,
  navElmButtom: any,
  categoryBarElm: any
) => {
  if (
    Math.trunc(section?.getBoundingClientRect().top!) <= offset &&
    navElmButtom > offset
  ) {
    if (!navElm?.classList.contains(`${styles.cat_button_select}`)) {
      navElm?.classList.add(`${styles.cat_button_select}`);
      categoryBarElm!.scrollTo({
        top: 0,
        left:
          categoryBarElm!.scrollLeft +
          navElm!.getBoundingClientRect().left -
          marginLeft,
        behavior: "smooth",
      });
    }
  } else {
    navElm?.classList.remove(`${styles.cat_button_select}`);
  }
};

export function handleScroll(categories: any) {
  categories?.forEach((cat: any) => {
    const section = document.querySelector<HTMLElement>(`#category_${cat.id}`);
    const navElm = document.querySelector<HTMLElement>(`#navElm_${cat.id}`);
    const categoryBarElm =
      document.querySelector<HTMLElement>("#category_bar ul");
    const offset = categoryBarElm?.getBoundingClientRect().top! + headerOffset;
    const navElmButtom = Math.trunc(section?.getBoundingClientRect().bottom!);
    updateCategoryTab(section, navElm, offset, navElmButtom, categoryBarElm);
  });
}

export const backToPreviousPosition = (setScrollYOfCategoryScreen: any) => {
  setScrollYOfCategoryScreen && setScrollYOfCategoryScreen(window.pageYOffset);
};
